import React, { useEffect } from "react";
import "./style.scss";
import { ProgressBar } from "react-bootstrap";
import CalendarIcon from "../../icons/CalendarIcon";
import { useNavigate, useOutletContext } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import Sidebar from "../../components/sidebar";
import PlusIcon from "../../icons/PlusIcon";
import LineGraphIcon from "../../icons/LineGraphIcon";
import CircleTickGreenIcon from "../../icons/CircleTickGreenIcon";
import AwardIcon from "../../icons/AwardIcon";
import TimerIcon from "../../icons/TimerIcon";
import CrossIcon from "../../icons/CrossIcon";
import AwardBlackIcon from "../../icons/AwardBlackIcon";
import HomeIcon from "../../icons/HomeIcon";
import LineUpIcon from "../../icons/LineUpIcon";
import BrainIcon from "../../icons/BrainIcon";
import StopRedIcon from "../../icons/StopRedIcon";
import PlusBlueIcon from "../../icons/PlusBlueIcon";
import { useDispatch, useSelector } from "react-redux";
import { getOwnerDashoard } from "../../core/data/redux/dashboard/_dashboardAction";
import CircularProgress from "../../core/components/CircularProgress";
import CircleTickGreyIcon from "../../icons/CircleTickGreyIcon";
import AlertRedIcon from "../../icons/AlertRedIcon";
import AuditTrailIcon from "../../icons/AuditTrailIcon";
import HomeRedIcon from "../../icons/HomeRedIcon";
import TimerGreyIcon from "../../icons/TimerGreyIcon";
import {
  formatDateString,
  formatDateStringType,
  getDateRangeFromData,
  logHourFormatTime,
} from "../../constants/date";
import { getStorageItem, setStorageItem } from "../../services/storage.service";
import { getUserProfile } from "../../core/data/redux/user/_userAction";

export default function Dashboard() {
  const { isSidebarOpen, onToggleSidebar } = useOutletContext<{
    isSidebarOpen: boolean;
    onToggleSidebar: () => void;
  }>();
  const dispatch: any = useDispatch();
  const navigate = useNavigate();
  const routes = all_routes;

  const ownerDashboardState = useSelector((state: any) => state?.dashboard);
  const dashboardData = ownerDashboardState?.ownerDashoard;

  const userDetail: any = getStorageItem("userData") || null;
  const userData = userDetail !== null ? JSON.parse(userDetail) : null;
  const planPermission = userData?.plan_permissions;


  useEffect(() => {
    fertchDashboardData();

    // set updated user data in firstlime login
    if ((userData?.role?.toLowerCase() === "owner") && !planPermission) {
      fetchUserDetails();
    }

  }, [dispatch]);

  const fetchUserDetails = async () => {
    try {
      const response: any = await dispatch(getUserProfile({}));
      const userDetails = response?.payload || response;

      if (userDetails) {
        if (planPermission?.plan_name.toLowerCase() !== userDetails?.plan_permissions?.plan_name.toLowerCase()) {
          setStorageItem("userData", JSON.stringify(userDetails));
        }
      }
    } catch (err) {
      console.error("Failed to fetch user details:", err);
    }
  };

  const fertchDashboardData = async () => {
    await dispatch(getOwnerDashoard({}));
  };

  return (
    <>
      <div className="layout">
        {/* Sidebar */}
        <Sidebar isOpen={isSidebarOpen} />

        {/* Main Content */}
        <main className="content dashboardPageWrapper">
          <div className="dashboardPage">
            <div className="profileSettings">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="d-flex flex-wrap justify-content-between align-items-center gap-3">
                      <h1 className="m-0 pageTitle">Dashboard</h1>
                      <div className="d-flex flex-wrap gap-2 align-items-center">
                        <button
                          className="primaryButton"
                          onClick={() => navigate(routes.addProperties)}
                        >
                          <PlusIcon /> Add Property
                        </button>
                        <button
                          className="primaryButton"
                          onClick={() => navigate(routes.addLogHours)}
                        >
                          <PlusIcon /> Add Log Hours
                        </button>
                        <button
                          className="primaryButton"
                          onClick={() => navigate(routes.addMileage)}
                        >
                          <PlusIcon /> Add Mileage
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row mt-4">
                  <div className="col-lg-8 col-xl-8 col-xxl-9">
                    <div className="row align-items-stretch resize">
                      <div className="col-md-12 col-xl-12 col-xxl-6 mb-4">
                        <div className="graphWrapper">
                          <div className="graphWrapperInner">
                            <div className="hours-progress">
                              <h3 className="text-white">750-Hours Progress</h3>
                              <CircularProgress
                                value={dashboardData?.total_completed_hours}
                                total={750}
                              />
                            </div>

                            <div className="time-period">
                              <h3 className="primaryText">
                                <LineGraphIcon />{" "}
                                {dashboardData?.completed_percentage}% Complete
                              </h3>
                              <div className="hours-complete d-flex gap-3 align-items-center">
                                <TimerIcon />
                                <div className="d-flex flex-column">
                                  <label>Hours Completed</label>
                                  <strong>
                                    {dashboardData?.total_completed_hours}
                                  </strong>
                                </div>
                              </div>
                              <div className="hours-remaining d-flex gap-3 align-items-center">
                                <LineUpIcon />
                                <div className="d-flex flex-column">
                                  <label>Hours Remaining</label>
                                  <strong>
                                    {dashboardData?.total_remaining_hours}
                                  </strong>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="progressWrapper">
                            <div className="d-flex w-100 justify-content-between gap-2">
                              <label>Overall Progress</label>
                              <span>
                                {dashboardData?.completed_percentage}%
                              </span>
                            </div>
                            <ProgressBar
                              now={dashboardData?.completed_percentage}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-md-12 col-xl-12 col-xxl-6  mb-4">
                        <div className="dashboardBlock">
                          {dashboardData?.material_participation_status?.total > 0 ? (
                            <>
                              <h3>
                                <LineGraphIcon /> Material Participation Status
                              </h3>
                              <div className="qualifyProperties">
                                <div className="progressWrapper">
                                  <ProgressBar now={dashboardData?.material_participation_status?.qualification_rate} />
                                </div>
                                <div className="d-flex gap-2 justify-content-between align-items-center mt-2">
                                  <p className="mb-0 rateWrap">{dashboardData?.material_participation_status?.qualification_rate} % Qualification Rate</p>
                                  <label>{dashboardData?.material_participation_status?.qualified}/{dashboardData?.material_participation_status?.total}</label>
                                </div>
                              </div>

                              <h3>Qualification Test</h3>
                              <ul className="testReport">
                                <li className="d-flex justify-content-between gap-2">
                                  <div className="d-flex gap-2 align-items-center">
                                    {
                                      dashboardData?.material_participation_status?.qualification_list?.[`500hr_status`].toLowerCase() == "not started"
                                        ? <TimerIcon />
                                        : dashboardData?.material_participation_status?.qualification_list?.[`500hr_status`].toLowerCase() == "in progress"
                                          ? <TimerIcon />
                                          : dashboardData?.material_participation_status?.qualification_list?.[`500hr_status`].toLowerCase() == "needs attention" ? <CrossIcon />
                                            : <CircleTickGreenIcon />
                                    }
                                    <label>Test 1: 500hr Status</label>
                                  </div>
                                  <div
                                    className={
                                      dashboardData?.material_participation_status?.qualification_list?.[`500hr_status`].toLowerCase() == "not started"
                                        ? "greyText"
                                        : dashboardData?.material_participation_status?.qualification_list?.[`500hr_status`].toLowerCase() == "in progress"
                                          ? "yellowText"
                                          : dashboardData?.material_participation_status?.qualification_list?.[`500hr_status`].toLowerCase() == "needs attention" ? "redText"
                                            : "greenText"
                                    }
                                  >
                                    {dashboardData?.material_participation_status?.qualification_list?.[`500hr_status`]}
                                  </div>
                                </li>

                                <li className="d-flex justify-content-between gap-2">
                                  <div className="d-flex gap-2 align-items-center">
                                    {
                                      dashboardData?.material_participation_status?.qualification_list?.[`substantially_status`].toLowerCase() == "not started"
                                        ? <TimerIcon />
                                        : dashboardData?.material_participation_status?.qualification_list?.[`substantially_status`].toLowerCase() == "partially qualified"
                                          ? <TimerIcon />
                                          : dashboardData?.material_participation_status?.qualification_list?.[`substantially_status`].toLowerCase() == "needs attention" ? <CrossIcon />
                                            : <CircleTickGreenIcon />
                                    }
                                    <label>Test 2: Substantially All</label>
                                  </div>
                                  <div
                                    className={
                                      dashboardData?.material_participation_status?.qualification_list?.[`substantially_status`].toLowerCase() == "not started"
                                        ? "greyText"
                                        : dashboardData?.material_participation_status?.qualification_list?.[`substantially_status`].toLowerCase() == "partially qualified"
                                          ? "yellowText"
                                          : dashboardData?.material_participation_status?.qualification_list?.[`substantially_status`].toLowerCase() == "needs attention" ? "redText"
                                            : "greenText"
                                    }
                                  >
                                    {dashboardData?.material_participation_status?.qualification_list?.[`substantially_status`]}
                                  </div>
                                </li>

                                <li className="d-flex justify-content-between gap-2">
                                  <div className="d-flex gap-2 align-items-center">
                                    {
                                      dashboardData?.material_participation_status?.qualification_list?.[`100hr_status`].toLowerCase() == "not started"
                                        ? <TimerIcon />
                                        : dashboardData?.material_participation_status?.qualification_list?.[`100hr_status`].toLowerCase() == "in progress"
                                          ? <TimerIcon />
                                          : dashboardData?.material_participation_status?.qualification_list?.[`100hr_status`].toLowerCase() == "needs attention" ? <CrossIcon />
                                            : <CircleTickGreenIcon />
                                    }
                                    <label>Test 3: 100hr Most Work</label>
                                  </div>
                                  <div
                                    className={
                                      dashboardData?.material_participation_status?.qualification_list?.[`100hr_status`].toLowerCase() == "not started"
                                        ? "greyText"
                                        : dashboardData?.material_participation_status?.qualification_list?.[`100hr_status`].toLowerCase() == "in progress"
                                          ? "yellowText"
                                          : dashboardData?.material_participation_status?.qualification_list?.[`100hr_status`].toLowerCase() == "needs attention" ? "redText"
                                            : "greenText"
                                    }
                                  >
                                    {dashboardData?.material_participation_status?.qualification_list?.[`100hr_status`]}
                                  </div>
                                </li>

                                <li className="d-flex justify-content-between gap-2">
                                  <div className="d-flex gap-2 align-items-center">
                                    {
                                      dashboardData?.material_participation_status?.qualification_list?.[`aggregate_status`].toLowerCase() == "not started"
                                        ? <TimerIcon />
                                        : dashboardData?.material_participation_status?.qualification_list?.[`aggregate_status`].toLowerCase() == "in progress"
                                          ? <TimerIcon />
                                          : dashboardData?.material_participation_status?.qualification_list?.[`aggregate_status`].toLowerCase() == "needs attention" ? <CrossIcon />
                                            : <CircleTickGreenIcon />
                                    }
                                    <label>Test 4: Aggregate 500hr</label>
                                  </div>
                                  <div
                                    className={
                                      dashboardData?.material_participation_status?.qualification_list?.[`aggregate_status`].toLowerCase() == "not started"
                                        ? "greyText"
                                        : dashboardData?.material_participation_status?.qualification_list?.[`aggregate_status`].toLowerCase() == "in progress"
                                          ? "yellowText"
                                          : dashboardData?.material_participation_status?.qualification_list?.[`aggregate_status`].toLowerCase() == "needs attention" ? "redText"
                                            : "greenText"
                                    }
                                  >
                                    {dashboardData?.material_participation_status?.qualification_list?.[`aggregate_status`]}
                                  </div>
                                </li>
                              </ul>
                            </>
                          ) : (
                            <div className="">
                              <h3>
                                <LineGraphIcon /> Start Tracking Your Material Participation
                              </h3>
                              <p className="mb-2">Begin logging your hours to see real-time progress toward IRS Material Participation qualifications across all four tests.</p>
                              <h3>Qualification Test</h3>
                              <ul className="testReport">
                                <li className="d-flex justify-content-between gap-2">
                                  <div className="d-flex gap-2 align-items-center">
                                    <CircleTickGreenIcon />
                                    <label>Test 1: 500hr Status</label>
                                  </div>
                                </li>
                                <li className="d-flex justify-content-between gap-2">
                                  <div className="d-flex gap-2 align-items-center">
                                    <TimerIcon />
                                    <label>Test 2: Substantially All</label>
                                  </div>
                                </li>
                                <li className="d-flex justify-content-between gap-2">
                                  <div className="d-flex gap-2 align-items-center">
                                    <CircleTickGreenIcon />
                                    <label>Test 3: 100hr Most Work</label>
                                  </div>
                                </li>
                                <li className="d-flex justify-content-between gap-2">
                                  <div className="d-flex gap-2 align-items-center">
                                    <CrossIcon />
                                    <label>Test 4: Aggregate 500hr</label>
                                  </div>
                                </li>
                              </ul>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    {dashboardData?.assigned_properties?.length > 0 && (
                      <>
                        <div className="row">
                          <div className="col-sm-12">
                            <h3>
                              <AwardBlackIcon /> Property Portfolio
                            </h3>
                          </div>
                        </div>

                        <div className="row align-items-strecth">
                          {dashboardData?.assigned_properties
                            ?.slice(0, 4)
                            .map((item: any, index: number) => (
                              <div className="col-xxl-6 col-xl-12 col-lg-12 d-flex mb-4">
                                <div
                                  className={`dashboardBlock ${item?.status === "success" ? "greenBg" : item?.status === "pending" ? "lightYellowBg" : item?.status === "alert" ? "redbg" : "greenBg"} w-100`}
                                >
                                  <div className="d-flex justify-content-between gap-2">
                                    <div className="d-flex gap-2">
                                      <HomeIcon />
                                      <div className="d-flex flex-column gap-2">
                                        <h4 className="mb-0">{item?.name}</h4>
                                        <p className="mb-0">
                                          {item?.address}, {item?.city},{" "}
                                          {item?.state}
                                        </p>
                                      </div>
                                    </div>
                                    {item?.status === "success" ? (
                                      <CircleTickGreenIcon />
                                    ) : item?.status === "pending" ? (
                                      <TimerIcon />
                                    ) : item?.status === "alert" ? (
                                      <AlertRedIcon />
                                    ) : (
                                      <CircleTickGreenIcon />
                                    )}
                                  </div>

                                  {item?.track_hours?.total && (
                                    <div className="d-flex my-2 gap-2 justify-content-between">
                                      <p className="mb-0">Hours Logged:</p>
                                      <h4 className="mb-0">
                                        {item?.track_hours?.total?.hours}.
                                        {item?.track_hours?.total?.minutes} hrs
                                      </h4>
                                    </div>
                                  )}

                                  <div className="mt-2">
                                    <h4>Material Participation Tests</h4>

                                    <ul className="materialList">
                                      <li className={(item?.material_participation_tests?.["500hr_status"]) ? "greenText" : "greyText"}>
                                        {(item?.material_participation_tests?.["500hr_status"]) ? <CircleTickGreenIcon /> : <CircleTickGreyIcon />} 500hr Status
                                      </li>
                                      <li className={(item?.material_participation_tests?.["substantially_status"]) ? "greenText" : "greyText"}>
                                        {(item?.material_participation_tests?.["substantially_status"]) ? <CircleTickGreenIcon /> : <CircleTickGreyIcon />} Substantially All
                                      </li>
                                      <li className={(item?.material_participation_tests?.["100hr_status"]) ? "greenText" : "greyText"}>
                                        {(item?.material_participation_tests?.["100hr_status"]) ? <CircleTickGreenIcon /> : <CircleTickGreyIcon />} 100hr Most Work
                                      </li>
                                      <li className={(item?.material_participation_tests?.["aggregate_status"]) ? "greenText" : "greyText"}>
                                        {(item?.material_participation_tests?.["aggregate_status"]) ? <CircleTickGreenIcon /> : <CircleTickGreyIcon />} Aggregate 500hr
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            ))}
                        </div>
                      </>
                    )}

                    {dashboardData?.recent_audit_trial?.length > 0 && (
                      <>
                        <div className="row">
                          <div className="col-sm-12">
                            <h3>
                              <AuditTrailIcon /> Audit Trail
                            </h3>
                          </div>
                        </div>

                        <div className="row align-items-strecth auditTrail">
                          {dashboardData?.recent_audit_trial
                            ?.slice(0, 4)
                            .map((item: any, index: number) => (
                              <div className="col-xxl-6 col-xl-12 col-lg-12 d-flex mb-4">
                                <div
                                  className={`dashboardBlock success ${item?.time ? "lightYellowBg" : "greenBg"} w-100`}
                                >
                                  <div className="d-flex justify-content-between gap-2 flex-wrap">
                                    <label
                                      className={`${item?.user_role?.toLowerCase() == "spouse" ? "redbg" : "purplebg"}`}
                                    >
                                      {item?.user_role ||
                                        "Real Estate Professional"}
                                    </label>
                                    <label className="blackbg">
                                      {formatDateStringType(item?.date)}
                                    </label>
                                  </div>
                                  <h4>{item?.action}</h4>

                                  {item?.property && (
                                    <label className="redbg m-1">
                                      <HomeRedIcon /> {item?.property?.address},{" "}
                                      {item?.property?.city},{" "}
                                      {item?.property?.state}
                                    </label>
                                  )}

                                  {item?.time && (
                                    <label className="lightbluebg m-1">
                                      <TimerGreyIcon />
                                      &nbsp;
                                      {logHourFormatTime({
                                        hours: item?.time?.hours,
                                        minutes: item?.time?.minutes,
                                      })}
                                    </label>
                                  )}
                                  <p>
                                    <strong>Details:</strong> {item?.details}
                                  </p>
                                  <ul className="d-flex gap-2 flex-wrap mt-3">
                                    <li>
                                      <strong>IP:</strong> {item?.ip_address}
                                    </li>
                                    <li>
                                      <strong>Device:</strong>{" "}
                                      {item?.device_type}
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            ))}
                        </div>
                      </>
                    )}

                    <div className="row resize">
                      <div className="col-xxl-6 col-xl-12 col-lg-12 mb-4">
                        <div className="dashboardBlock w-100">
                          <h3 className="font24px mb-4">
                            <CalendarIcon /> Weekly Summary{" "}
                            <span>
                              {getDateRangeFromData(
                                dashboardData?.weekly_summary
                                  ?.daily_logged_hours
                              )}
                            </span>
                          </h3>

                          <div className="summaryBlocks block_multi_color">
                            <ul>
                              <li className="bluebg gap-2 align-items-center d-flex flex-column text-center">
                                <label>
                                  {dashboardData?.weekly_summary?.hours}
                                </label>
                                <h4 className="mb-0">Hours This Week</h4>
                                <p className="mb-0">
                                  Goal: {dashboardData?.weekly_summary?.goal}{" "}
                                  hrs (
                                  {dashboardData?.weekly_summary?.percentage}%)
                                </p>
                              </li>
                              <li className="greenbg gap-2 align-items-center d-flex flex-column text-center">
                                <label>
                                  {dashboardData?.weekly_summary?.activities}
                                </label>
                                <h4 className="mb-0">Activities Logged</h4>
                              </li>
                              <li className="redbg gap-2 align-items-center d-flex flex-column text-center">
                                <label>
                                  {dashboardData?.weekly_summary?.properties}
                                </label>
                                <h4 className="mb-0">Properties Worked</h4>
                              </li>
                            </ul>
                          </div>

                          <h3 className="font24px mt-4">Daily Breakdown </h3>
                          <div className="chart-container-inner  mt-4">
                            <div className="chart-container">
                              {dashboardData?.weekly_summary?.daily_logged_hours?.map(
                                (dayData: any, index: any) => (
                                  <div key={index} className="bar-container">
                                    <span className="bar-label">
                                      {dayData?.total}h
                                    </span>
                                    <div
                                      className="bar"
                                      style={{
                                        height: `${(dayData?.total / 24) * 100}%`,
                                      }} // Scale height based on max 7h
                                    ></div>
                                    <div className="day-label">
                                      {dayData?.day.slice(0, 3)}
                                    </div>
                                  </div>
                                )
                              )}
                            </div>
                          </div>

                          <div className="weeklyGoal">
                            <LineUpIcon />{" "}
                            {dashboardData?.weekly_summary?.pending_hours} hours
                            remaining to reach weekly goal
                          </div>
                        </div>
                      </div>

                      <div className="col-xxl-6 col-xl-12 col-lg-12 mb-4">
                        <div className="dashboardBlock bg-white w-100">
                          <h3 className="font24px">
                            <BrainIcon /> AI Insights{" "}
                            <span className="badge">Smart Analysis</span>
                          </h3>

                          <div className="summaryBlocks mb-4">
                            <h5>Property Status Overview</h5>
                            <ul>
                              <li className="bluebg gap-3 align-items-center d-flex flex-column text-center">
                                <CircleTickGreenIcon />
                                <h4 className="mb-0 greenText">{dashboardData?.ai_insights?.qualified || 0}</h4>
                                <p className="mb-0 greenText">Qualified</p>
                              </li>
                              <li className="greenbg gap-3 align-items-center d-flex flex-column text-center">
                                <TimerIcon />
                                <h4 className="mb-0 yellowText">{dashboardData?.ai_insights?.progress || 0}</h4>
                                <p className="mb-0 yellowText">In Progress</p>
                              </li>
                              <li className="redbg gap-3 align-items-center d-flex flex-column text-center">
                                <StopRedIcon />
                                <h4 className="mb-0 redText">{dashboardData?.ai_insights?.risk || 0}</h4>
                                <h4 className="mb-0 redText">At Risk</h4>
                              </li>
                            </ul>
                          </div>

                          <h3><BrainIcon /> Smart Recommendations</h3>
                          {dashboardData?.ai_insights?.recomendations?.length > 0 ? (

                            dashboardData?.ai_insights?.recomendations?.map((item: any, index: any) => (
                              <ul className="mt-2">
                                <li className="redbg my-2 d-flex gap-2 p-3 rounded-3 justify-content-between">
                                  <div className="d-flex flex-column">
                                    <h5 className={`${item?.priority_level?.toLowerCase() == "high" ? "redText" : "yellowText"} mb-0`}>{item?.title}</h5>
                                    <p className={`${item?.priority_level?.toLowerCase() == "high" ? "redText" : "yellowText"} mb-0`}>{item?.message}</p>
                                  </div>
                                  <h4
                                    style={{ textTransform: 'uppercase' }}
                                    className={`${item?.priority_level?.toLowerCase() == "high" ? "redText" : "yellowText"} mb-0 fw-normal`}
                                  >
                                    {item?.priority_level}
                                  </h4>
                                </li>
                              </ul>
                            ))
                          ) : (
                            <p className="m-4">No recommendations available.</p>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-sm-12">
                        <div className="dashboardBlock bg-white w-100">
                          <h3>
                            <TimerIcon /> Recent Activity
                          </h3>

                          {dashboardData?.recent_activity?.length > 0 ? (
                            dashboardData?.recent_activity
                              ?.slice(0, 3)
                              .map((item: any, index: any) => (
                                <ul className="recentList">
                                  <li className="d-flex gap-2 justify-content-between">
                                    <div className="d-flex justify-content-between gap-3 recentText">
                                      {item?.status?.toLowerCase() ===
                                        "achieved" ? (
                                        <CircleTickGreenIcon />
                                      ) : (
                                        <PlusBlueIcon />
                                      )}
                                      <div className="recentText d-flex flex-column">
                                        <h5 className="mb-0">
                                          {item?.details}
                                        </h5>
                                        {item?.property && (
                                          <p className="mb-0 greyText">
                                            {item?.property}
                                          </p>
                                        )}
                                        {item?.time && (
                                          <p className="mb-0 blueText">
                                            {item?.time?.hours}.
                                            {item?.time?.minutes} hours
                                          </p>
                                        )}
                                      </div>
                                    </div>
                                    <span>{formatDateString(item?.date)}</span>
                                  </li>
                                </ul>
                              ))
                          ) : (
                            <p className="m-4">No recent activity available.</p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-4 col-xl-4 col-xxl-3">
                    <div className="sideWidget">
                      <div className="dashboardBlock achievements-area">
                        <h3 className="achievements-text d-flex gap-2 flex-wrap align-items-center mb-3">
                          <AwardIcon /> Achievements{" "}
                          <span className="earnbadge">
                            {dashboardData?.achievements?.total || 0} earned
                          </span>
                        </h3>

                        <h3 className="earned-badges-area">Earned Badges</h3>
                        {dashboardData?.achievements?.earned_badges?.length >
                          0 ? (
                          dashboardData?.achievements?.earned_badges?.map(
                            (item: any, index: any) => (
                              <>
                                <div className="activityWrapper text-center">
                                  <div className="achievement-icon-area">
                                    <img
                                      src={item?.icon}
                                      alt="achievement icon"
                                    />
                                  </div>
                                  <h3 className="mt-3">{item?.name}</h3>
                                  <p>{item?.description}</p>
                                  <p>{formatDateString(item?.date)}</p>
                                </div>
                              </>
                            )
                          )
                        ) : (
                          <p className="m-3">No badges earned yet.</p>
                        )}

                        <h3>Available Achievements</h3>
                        {dashboardData?.achievements?.available_achievements
                          ?.length > 0 ? (
                          dashboardData?.achievements?.available_achievements?.map(
                            (item: any, index: any) => (
                              <>
                                <div className="achievementsWrapper text-center">
                                  <div className="achievement-icon-area">
                                    <img
                                      src={item?.icon}
                                      alt="achievement icon"
                                    />
                                  </div>
                                  <h3 className="mt-3">{item?.name}</h3>
                                  <p>{item?.description}</p>
                                </div>
                              </>
                            )
                          )
                        ) : (
                          <p className="m-4">No badges available yet.</p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
}
